// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .pipeline .card-body[data-v-2327ff34] {\n  padding: 0.5rem 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
